
import { AuthId } from "@common/constans";
import { IAvailabilityRequest, IAvalaibilityResponse, IContactModifyRequest, IModificationPricingInfo, IModificationRequest, IModificationTotalPriceRequest, IOriginDestination, IPnrInfo, IResponse } from "@common/models";
import Api, { IOptions } from "@service/Api";
import { Action } from "./Proxy";

export function modifyContact<T = IContactModifyRequest, U = IPnrInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Modification/Contact", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function modificationAvailability<T = IAvailabilityRequest, U = IAvalaibilityResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.GET:
            return Api.get<T, U>("Modification/Availability", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
        case Action.POST:
            return Api.post<T, U>("Modification/Availability", {
                ...options,
                raiseError: options?.raiseError ?? false,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function modificationTotalPrice<T = IModificationTotalPriceRequest, U = IOriginDestination[]>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Modification/TotalPrice", { ...options, raiseError: options?.raiseError ?? false });
    }
    return Promise.reject();
}

export function modifyPricing<T = IModificationRequest, U = IModificationPricingInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Modification/Pricing", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function freeModificationConfirm<T = IModificationRequest, U = IPnrInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Modification/Confirm", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function modificationInitialize<T = IModificationRequest, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Modification/Initialize", { ...options, raiseError: options?.raiseError ?? false });
    }
    return Promise.reject();
}

export function modificationWithoutPayment<T = IModificationRequest, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Modification/ModificationWithoutPayment", { ...options, raiseError: options?.raiseError ?? false });
    }
    return Promise.reject();
}